// Mobile breakpoint mirrors $size: xs in _Config.scss (max-width: 767px).
// Below it accordions collapse; at sm+ the CSS forces them open — unless the
// container is .collapsible-on-desktop, in which case they collapse everywhere.
const MOBILE_QUERY = '(max-width: 767px)';
const DURATION = 300;
// Padding is animated alongside height so the body collapses to a true 0 —
// otherwise the .accordion-body's own padding leaves a sliver that snaps away
// when display:none kicks in (a small "jump" at the end of closing).
const TRANSITION = 'height ' + DURATION + 'ms ease-out, padding ' + DURATION + 'ms ease-out';

const Accordion = (accordion) => {

	const toggleBtn = accordion.querySelector('.toggle-btn');
	const body = accordion.querySelector('.accordion-body');
	if(!toggleBtn || !body) {
		return ;
	}

	const mobile = window.matchMedia(MOBILE_QUERY);
	const collapsibleOnDesktop = !!accordion.closest('.collapsible-on-desktop');

	// State (seeded from the markup so server-revealed accordions start open)
	let isOpen = accordion.getAttribute('data-revealed') === 'true';

	// True whenever the accordion is actually toggleable and should animate.
	const isAnimated = () => mobile.matches || collapsibleOnDesktop;

	const open = () => {
		isOpen = true;
		accordion.setAttribute('data-revealed', 'true');

		// Measure the natural open size (height incl. its own padding).
		body.style.transition = 'none';
		body.style.display = 'block';
		body.style.removeProperty('height');
		body.style.removeProperty('padding-top');
		body.style.removeProperty('padding-bottom');
		const cs = window.getComputedStyle(body);
		const padTop = cs.paddingTop;
		const padBottom = cs.paddingBottom;
		const target = body.scrollHeight;

		// Snap to collapsed, commit it, then animate up to the measured size.
		body.style.height = '0';
		body.style.paddingTop = '0';
		body.style.paddingBottom = '0';
		body.offsetHeight; // Force reflow so the start frame is registered
		body.style.transition = TRANSITION;
		body.style.height = target + 'px';
		body.style.paddingTop = padTop;
		body.style.paddingBottom = padBottom;

		body.addEventListener('transitionend', function onEnd(e) {
			if(e.target !== body || e.propertyName !== 'height') { return ; }
			body.removeEventListener('transitionend', onEnd);
			// Release to auto so it adapts to reflow while open.
			if(isOpen) {
				body.style.height = 'auto';
				body.style.removeProperty('padding-top');
				body.style.removeProperty('padding-bottom');
			}
		});
	};

	const close = () => {
		isOpen = false;
		accordion.setAttribute('data-revealed', 'false');

		// Pin the current pixel height/padding so they can animate to 0.
		const cs = window.getComputedStyle(body);
		body.style.transition = 'none';
		body.style.height = body.scrollHeight + 'px';
		body.style.paddingTop = cs.paddingTop;
		body.style.paddingBottom = cs.paddingBottom;
		body.offsetHeight; // Force reflow
		body.style.transition = TRANSITION;
		body.style.height = '0';
		body.style.paddingTop = '0';
		body.style.paddingBottom = '0';

		body.addEventListener('transitionend', function onEnd(e) {
			if(e.target !== body || e.propertyName !== 'height') { return ; }
			body.removeEventListener('transitionend', onEnd);
			if(!isOpen) { body.style.display = 'none'; }
		});
	};

	const toggle = (e) => {
		if(e) { e.preventDefault(); }
		if(!isAnimated()) { return ; } // Desktop: CSS keeps it open, btn is hidden
		isOpen ? close() : open();
	};

	// Apply the resting inline styles for the height animation.
	const enableAnimation = () => {
		body.style.overflow = 'hidden';
		body.style.transition = 'none';
		if(isOpen) {
			body.style.display = 'block';
			body.style.height = 'auto';
			body.style.removeProperty('padding-top');
			body.style.removeProperty('padding-bottom');
		}
		else {
			body.style.display = 'none';
			body.style.height = '0';
			body.style.paddingTop = '0';
			body.style.paddingBottom = '0';
		}
	};

	// Hand control back to the CSS (desktop, non-collapsible accordions).
	const clearInline = () => {
		body.style.removeProperty('height');
		body.style.removeProperty('overflow');
		body.style.removeProperty('transition');
		body.style.removeProperty('display');
		body.style.removeProperty('padding-top');
		body.style.removeProperty('padding-bottom');
	};

	const syncMode = () => {
		isAnimated() ? enableAnimation() : clearInline();
	};

	toggleBtn.addEventListener('click', toggle);
	mobile.addEventListener('change', syncMode);

	syncMode();

	return {
		open,
		close,
		toggle,
	};
};

export default Accordion;
